import { render, staticRenderFns } from "./MedUserVerify.vue?vue&type=template&id=b6faff2c&"
import script from "./MedUserVerify.vue?vue&type=script&lang=js&"
export * from "./MedUserVerify.vue?vue&type=script&lang=js&"
import style0 from "./MedUserVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports